import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { DocHit } from '../models/review/doc-hit';

@Injectable({
	providedIn: 'root'
})
export class DocHitsService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	getHits(docId: string): Observable<DocHit[]> {
		let url = `${this.appConfigService.getConfig().webApi}/api2/DocHits?docId=${docId}`;
		const query = localStorage.getItem('searchQuery');
		if (query) url += `&query=${query}`;

		return this.http.get<DocHit[]>(url).pipe(catchError(this.errorHandler.handleError<DocHit[]>(`get hits`)));
	}
}
